import { Alert, Button, Col, Form, Input, InputNumber, Modal, Row, Select, Table } from 'antd';
import { Helmet } from 'react-helmet-async';
import { useEffect, useState } from 'react';
import { EditOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { apiCall } from '../../API/RestApi';
import { modalError } from '../../Component/Modal/ModalLayout';
import { useSelector } from 'react-redux';
import Search from 'antd/es/input/Search';

function KpiTask() {
    const token = useSelector((state) => state.user.token);
    const [data, setData] = useState([]);
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(false);
    const [isModal, setIsModal] = useState(false);
    const [dataModal, setdataModal] = useState(null);
    const [form] = Form.useForm();
    const [page, setPage] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
        },
        sorter: {
            order: 'desc',
            columnKey: 'kpi_task_id',
        }
    });
    const [isAlert, setIsAlert] = useState(false);
    const [textAlert, setTextAlert] = useState(false);

    const titlePage = 'KPI Task Data';
    const columns = [
        {
            title: 'No',
            dataIndex: 'no',
            key: 'no',
            render: (id, record, index) => (page.pagination.current - 1) * page.pagination.pageSize + index + 1,
        },
        {
            title: 'Performance Area',
            dataIndex: 'perfomance_area',
            key: 'perfomance_area',
            sorter: true,
        },
        {
            title: 'Key Performance Indicators',
            dataIndex: 'perfomance_indicators',
            key: 'perfomance_indicators',
            sorter: true,
        },
        {
            title: 'Weight',
            dataIndex: 'weight',
            key: 'weight',
            sorter: true,
        },
        {
            title: 'Target',
            dataIndex: 'target',
            key: 'target',
            sorter: true,
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            render: (text, record) => (
                <>
                    <Button type="primary" style={{ marginRight: 10 }} onClick={() => openModal('edit', record)}>
                        <EditOutlined /> Edit
                    </Button>
                    <Button type="primary" danger onClick={() => modalDeleteData(record)}>
                        <DeleteOutlined /> Delete
                    </Button>
                </>
            ),
        },
    ];

    useEffect(() => {
        const order = page.sorter?.order === 'ascend' ? 'asc' : 'desc';
        const columnKey = page.sorter?.columnKey || 'kpi_task_id';
        getApi('GET', `/kpitask?byuser=true&search=${search}&page=${page.pagination.current}&limit=${page.pagination.pageSize}&sortBy=${columnKey}&order=${order}`, 'kpitask');
    }, [JSON.stringify(page), isAlert]);

    const getApi = (method, url, type) => {
        setLoading(true);
        const dataReq = {
            method,
            url,
            data: {
                headers: {
                    Authorization: 'Bearer ' + token
                }
            }
        };
        apiCall(dataReq).then((res) => {
            if (res.status === 'success') {
                setData(res.data.data);
                setPage(prev => ({
                    ...prev,
                    pagination: {
                        ...prev.pagination,
                        total: res.data.total_data
                    }
                }));
            }
            setLoading(false);
        }).catch(() => setLoading(false));
    };

    const postApi = async (method, url, values) => {
        setLoading(true);
        setIsAlert(false);
        const dataReq = {
            method,
            url,
            data: {
                data: values,
                headers: {
                    Authorization: 'Bearer ' + token
                }
            }
        };
        apiCall(dataReq).then((res) => {
            if (res.status === 'success') {
                setdataModal(null);
                setIsAlert(true);
                setTextAlert(res.message);
                closeModal();
            } else {
                modalError(res.message);
            }
            setLoading(false);
        }).catch(() => setLoading(false));
    };

    const modalDeleteData = (v) => {
        Modal.confirm({
            title: 'NOTICE',
            content: 'Do you want to delete this data?',
            onOk: () => postApi('DELETE', '/kpitask/' + v.kpi_task_id, null),
        });
    };

    const openModal = (type, data) => {
        if (type === 'edit') {
            setdataModal(data);
            form.setFieldsValue(data);
        }
        setIsModal(true);
    };

    const onFinish = (ev) => {
        if (dataModal) {
            postApi('PUT', '/kpitask/' + dataModal.kpi_task_id, ev);
        } else {
            postApi('POST', '/kpitask', ev);
        }
    };

    const closeModal = () => {
        setdataModal(null);
        setIsModal(false);
        form.resetFields();
    };

    const handleTableChange = (pagination, filters, sorter) => {
        setPage({
            pagination,
            filters,
            sorter,
        });
        if (pagination.pageSize !== page.pagination?.pageSize) setData([]);
    };

    const searchData = (value) => {
        setSearch(value);
        setPage({
            pagination: {
                current: 1,
                pageSize: 10,
            },
        });
    };

    return (
        <div>
            <Helmet>
                <title>{titlePage}</title>
            </Helmet>
            {isAlert && <Alert message={textAlert} type="success" banner closable afterClose={() => setIsAlert(false)} />}
            <h3>KPI Task</h3>
            <Row>
                <Col span={8}>
                    <Search placeholder="Search" allowClear enterButton="Search" size="middle" onSearch={searchData} />
                </Col>
                <Col span={16} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button style={{ marginBottom: 10 }} type="primary" onClick={() => openModal('add', null)}>
                        <PlusOutlined /> Add
                    </Button>
                </Col>
            </Row>
            <Table size="middle" columns={columns} dataSource={data} pagination={page.pagination} loading={loading} onChange={handleTableChange} />
            <Modal title="KPI Task Form" open={isModal} onOk={form.submit} onCancel={closeModal} okText="Save">
                <Form form={form} layout="vertical" onFinish={onFinish}>
                    <Form.Item name="perfomance_area" label="Performance Area" rules={[{ required: true, message: 'Performance Area is required!' }]}> <Input /> </Form.Item>
                    <Form.Item name="perfomance_indicators" label="Key Performance Indicators" rules={[{ required: true, message: 'KPI is required!' }]}> <Input /> </Form.Item>
                    <Form.Item name="weight" label="Weight" rules={[{ required: true, message: 'Weight is required!' }]}> <InputNumber style={{ width: '100%' }} /> </Form.Item>
                    <Form.Item name="target" label="Target" rules={[{ required: true, message: 'Target is required!' }]}> <InputNumber style={{ width: '100%' }} /> </Form.Item>
                    <Form.Item name="is_maximal" label="Status" rules={[{ required: true, message: 'Status is required!' }]}> <Select><Select.Option value={true}>Maximal</Select.Option><Select.Option value={false}>Minimal</Select.Option></Select> </Form.Item>
                </Form>
            </Modal>
        </div>
    );
}

export default KpiTask;
